// extracted by mini-css-extract-plugin
module.exports = {"InfoBox":"InfoBoxTemplate_InfoBox__3odJe"};